import React from 'react';
import { MessageCircle } from 'lucide-react';
import { siteInfo } from '../data/mock';

const WhatsAppButton = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      `¡Hola Luciana! Me gustaría información sobre tus servicios de maquillaje y peinado.`
    );
    window.open(`https://wa.me/${siteInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsApp}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg flex items-center justify-center whatsapp-pulse hover:bg-[#128C7E] transition-colors"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle size={28} fill="white" />
    </button>
  );
};

export default WhatsAppButton;
